import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenerateCvService {
  mainURL = 'api/';
  userId = localStorage.getItem('userInfoz');
  constructor(private http: HttpClient) {}

  private cvDataSubject = new BehaviorSubject<any>(null);
  data$ = this.cvDataSubject.asObservable();

  setData(data: any) {
    this.cvDataSubject.next(data);
  }

  getData() {
    return this.cvDataSubject.value;
  }

  sentCvJsonData(userId: string, data: any, cvType = 'generate-cv-pdf') {
    return this.http.post(
      environment.apiUrl + this.mainURL + userId + '/generate-cv-cl/' + cvType,
      data
    );
  }

  createCoverLetter(userId: string, data: any) {
    return this.http.post(
      environment.apiUrl + this.mainURL + userId + '/generate-cl',
      data
    );
  }

  uploadExistingCv(cv: FormData) {
   
    return this.http.post(
      environment.apiUrl + this.mainURL + 'upload-existing-cv',
      cv
    );
  }

  enhanceLinkedinCv(data: any) {
    return this.http.post(
      environment.apiUrl + this.mainURL + 'enhance-linkedin-cv',
      data
    );
  }
}
